import Dexie from "dexie"
import { importInto, exportDB } from "dexie-export-import"
import download from "downloadjs"

class Client {
  constructor() {
    this.db = new Dexie("ehon-inputsenpai-com")

    // Set version 1 stores
    this.db.version(1).stores({
      completedBooks: "url, title, age",
    })
  }

  async export(progressCb) {
    try {
      const blob = await exportDB(this.db, { progressCallback: progressCb })
      const now = new Date()
      const date = `${now.getFullYear()}-${now.getMonth() - 1}-${now.getDate()}`
      const time = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`
      const dateTime = `${date}${time}`
      download(blob, `ehon-${dateTime}.json`, 'application/json')
      return { status: 'OK' }
    } catch(e) {
      return { status: 'FAIL', error: e }
    }
  }

  async import(file, progressCb) {
    try {
      await importInto(this.db, file, { overwriteValues: true, progressCallback: progressCb })
      return { status: 'OK' }
    } catch(e) {
      return { status: 'FAIL', error: e }
    }
  }
}

export default Client
